import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { getMarketplaceMeta } from '../../utils/marketplaceBadge';

interface MarketplaceChipProps {
  externalPlatform: string | undefined;
  size?: 'xs' | 'sm';
}

const MarketplaceChip: React.FC<MarketplaceChipProps> = ({ externalPlatform, size = 'xs' }) => {
  const meta = getMarketplaceMeta(externalPlatform);
  if (!meta) return null;

  const isXs = size === 'xs';

  return (
    <Tooltip title={meta.fullLabel} placement="top" arrow>
      <Chip
        label={meta.shortLabel}
        size="small"
        sx={{
          height: isXs ? 16 : 20,
          fontSize: isXs ? '0.6rem' : '0.7rem',
          fontWeight: 600,
          textTransform: 'none',
          backgroundColor: meta.color,
          color: meta.textColor,
          '& .MuiChip-label': { px: 0.7 },
        }}
      />
    </Tooltip>
  );
};

export default MarketplaceChip;
